var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    {
      staticClass: "default documents",
      attrs: {
        "data-folder_id": _vm.topfolder.folder_id,
        "data-shiftcheck": ""
      }
    },
    [
      _c("caption", [
        _c("div", { staticClass: "caption-container" }, [
          _vm.breadcrumbs && !_vm.table_title
            ? _c(
                "div",
                [
                  _vm.breadcrumbs[0]
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.breadcrumbs[0].url,
                            title: "Zum Hauptordner".toLocaleString()
                          }
                        },
                        [
                          _c("studip-icon", {
                            staticClass: "text-bottom",
                            attrs: {
                              shape: "folder-home-full",
                              role: "clickable",
                              size: "30"
                            }
                          }),
                          _vm._v(" "),
                          _vm.breadcrumbs.length == 1
                            ? _c("span", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.breadcrumbs[0].name) +
                                    "\n                    "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.breadcrumbs, function(breadcrumb, index) {
                    return index > 0
                      ? _c("span", { key: breadcrumb.folder_id }, [
                          _vm._v("\n                    /"),
                          _c("a", { attrs: { href: breadcrumb.url } }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(breadcrumb.name) +
                                "\n                    "
                            )
                          ])
                        ])
                      : _vm._e()
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.table_title
            ? _c("div", [_vm._v(_vm._s(_vm.table_title))])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.topfolder.description
          ? _c("div", {
              staticStyle: { "font-size": "small" },
              domProps: { innerHTML: _vm._s(_vm.topfolder.description) }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "colgroup",
        [
          _vm.show_bulk_actions
            ? _c("col", { attrs: { width: "30px", "data-filter-ignore": "" } })
            : _vm._e(),
          _vm._v(" "),
          _c("col", { attrs: { width: "60px", "data-filter-ignore": "" } }),
          _vm._v(" "),
          _c("col"),
          _vm._v(" "),
          _c("col", {
            staticClass: "responsive-hidden",
            attrs: { width: "100px", "data-filter-ignore": "" }
          }),
          _vm._v(" "),
          _vm.showdownloads
            ? _c("col", {
                staticClass: "responsive-hidden",
                attrs: { width: "100px", "data-filter-ignore": "" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("col", {
            staticClass: "responsive-hidden",
            attrs: { width: "150px" }
          }),
          _vm._v(" "),
          _c("col", {
            staticClass: "responsive-hidden",
            attrs: { width: "120px", "data-filter-ignore": "" }
          }),
          _vm._v(" "),
          _vm._l(_vm.topfolder.additionalColumns, function(name, index) {
            return _vm.topfolder.additionalColumns
              ? _c("col", {
                  key: index,
                  staticClass: "responsive-hidden",
                  attrs: { "data-filter-ignore": "" }
                })
              : _vm._e()
          }),
          _vm._v(" "),
          _c("col", { attrs: { width: "80px", "data-filter-ignore": "" } })
        ],
        2
      ),
      _vm._v(" "),
      _c("thead", [
        _c(
          "tr",
          { staticClass: "sortable" },
          [
            _vm.show_bulk_actions
              ? _c(
                  "th",
                  { attrs: { "data-sort": "false" } },
                  [
                    _c("studip-proxy-checkbox", {
                      attrs: { total: _vm.allIds },
                      model: {
                        value: _vm.selectedIds,
                        callback: function($$v) {
                          _vm.selectedIds = $$v
                        },
                        expression: "selectedIds"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "th",
              {
                on: {
                  click: function($event) {
                    return _vm.sort("mime_type")
                  }
                }
              },
              [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s("Typ".toLocaleString()) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.sortedBy == "mime_type" && _vm.sortDirection == "asc"
                  ? _c("studip-icon", {
                      staticClass: "text-bottom",
                      attrs: {
                        shape: "arr_1down",
                        role: "clickable",
                        size: "16"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.sortedBy == "mime_type" && _vm.sortDirection == "desc"
                  ? _c("studip-icon", {
                      staticClass: "text-bottom",
                      attrs: { shape: "arr_1up", role: "clickable", size: "16" }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                on: {
                  click: function($event) {
                    return _vm.sort("name")
                  }
                }
              },
              [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s("Name".toLocaleString()) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.sortedBy == "name" && _vm.sortDirection == "asc"
                  ? _c("studip-icon", {
                      staticClass: "text-bottom",
                      attrs: {
                        shape: "arr_1down",
                        role: "clickable",
                        size: "16"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.sortedBy == "name" && _vm.sortDirection == "desc"
                  ? _c("studip-icon", {
                      staticClass: "text-bottom",
                      attrs: { shape: "arr_1up", role: "clickable", size: "16" }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "responsive-hidden",
                on: {
                  click: function($event) {
                    return _vm.sort("size")
                  }
                }
              },
              [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s("Größe".toLocaleString()) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.sortedBy == "size" && _vm.sortDirection == "asc"
                  ? _c("studip-icon", {
                      staticClass: "text-bottom",
                      attrs: {
                        shape: "arr_1down",
                        role: "clickable",
                        size: "16"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.sortedBy == "size" && _vm.sortDirection == "desc"
                  ? _c("studip-icon", {
                      staticClass: "text-bottom",
                      attrs: { shape: "arr_1up", role: "clickable", size: "16" }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.showdownloads
              ? _c(
                  "th",
                  {
                    staticClass: "responsive-hidden",
                    on: {
                      click: function($event) {
                        return _vm.sort("downloads")
                      }
                    }
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s("Downloads".toLocaleString()) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.sortedBy == "downloads" && _vm.sortDirection == "asc"
                      ? _c("studip-icon", {
                          staticClass: "text-bottom",
                          attrs: {
                            shape: "arr_1down",
                            role: "clickable",
                            size: "16"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.sortedBy == "downloads" && _vm.sortDirection == "desc"
                      ? _c("studip-icon", {
                          staticClass: "text-bottom",
                          attrs: {
                            shape: "arr_1up",
                            role: "clickable",
                            size: "16"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "responsive-hidden",
                on: {
                  click: function($event) {
                    return _vm.sort("author_name")
                  }
                }
              },
              [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s("Autor/-in".toLocaleString()) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.sortedBy == "author_name" && _vm.sortDirection == "asc"
                  ? _c("studip-icon", {
                      staticClass: "text-bottom",
                      attrs: {
                        shape: "arr_1down",
                        role: "clickable",
                        size: "16"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.sortedBy == "author_name" && _vm.sortDirection == "desc"
                  ? _c("studip-icon", {
                      staticClass: "text-bottom",
                      attrs: { shape: "arr_1up", role: "clickable", size: "16" }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "responsive-hidden",
                on: {
                  click: function($event) {
                    return _vm.sort("chdate")
                  }
                }
              },
              [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s("Datum".toLocaleString()) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.sortedBy == "chdate" && _vm.sortDirection == "asc"
                  ? _c("studip-icon", {
                      staticClass: "text-bottom",
                      attrs: {
                        shape: "arr_1down",
                        role: "clickable",
                        size: "16"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.sortedBy == "chdate" && _vm.sortDirection == "desc"
                  ? _c("studip-icon", {
                      staticClass: "text-bottom",
                      attrs: { shape: "arr_1up", role: "clickable", size: "16" }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.topfolder.additionalColumns, function(name, index) {
              return _vm.topfolder.additionalColumns
                ? _c(
                    "th",
                    {
                      key: index,
                      staticClass: "responsive-hidden",
                      on: {
                        click: function($event) {
                          return _vm.sort(index)
                        }
                      }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(name) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.sortedBy == index && _vm.sortDirection == "asc"
                        ? _c("studip-icon", {
                            staticClass: "text-bottom",
                            attrs: {
                              shape: "arr_1down",
                              role: "clickable",
                              size: "16"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sortedBy == index && _vm.sortDirection == "desc"
                        ? _c("studip-icon", {
                            staticClass: "text-bottom",
                            attrs: {
                              shape: "arr_1up",
                              role: "clickable",
                              size: "16"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _c("th", { attrs: { "data-sort": "false" } }, [
              _vm._v(_vm._s("Aktionen".toLocaleString()))
            ])
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        { staticClass: "subfolders" },
        [
          _vm.files.length + _vm.folders.length == 0
            ? _c("tr", { staticClass: "empty" }, [
                _c("td", { attrs: { colspan: _vm.numberOfColumns } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s("Dieser Ordner ist leer".toLocaleString()) +
                      "\n            "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.sortedFolders, function(folder) {
            return _c(
              "tr",
              {
                attrs: {
                  id: "row_folder_" + folder.id,
                  "data-permissions": folder.permissions
                }
              },
              [
                _vm.show_bulk_actions
                  ? _c(
                      "td",
                      [
                        _c("studip-proxied-checkbox", {
                          attrs: { name: "ids[]", value: folder.id },
                          model: {
                            value: _vm.selectedIds,
                            callback: function($$v) {
                              _vm.selectedIds = $$v
                            },
                            expression: "selectedIds"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("td", { staticClass: "document-icon" }, [
                  _c(
                    "a",
                    { attrs: { href: folder.url } },
                    [
                      _c("studip-icon", {
                        staticClass: "text-bottom",
                        attrs: {
                          shape: folder.icon,
                          role: "clickable",
                          size: "26"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("a", { attrs: { href: folder.url } }, [
                    _vm._v(_vm._s(folder.name))
                  ])
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "responsive-hidden" }),
                _vm._v(" "),
                _vm.showdownloads
                  ? _c("td", { staticClass: "responsive-hidden" })
                  : _vm._e(),
                _vm._v(" "),
                folder.author_url
                  ? _c("td", { staticClass: "responsive-hidden" }, [
                      _c("a", { attrs: { href: folder.author_url } }, [
                        _vm._v(_vm._s(folder.author_name))
                      ])
                    ])
                  : _c("td", { staticClass: "responsive-hidden" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(folder.author_name) +
                          "\n            "
                      )
                    ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "responsive-hidden" },
                  [
                    _c("studip-date-time", {
                      attrs: { timestamp: folder.chdate, relative: true }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.topfolder.additionalColumns, function(name, index) {
                  return _vm.topfolder.additionalColumns
                    ? [
                        folder.additionalColumns &&
                        folder.additionalColumns[index] &&
                        folder.additionalColumns[index].html
                          ? _c("td", {
                              staticClass: "responsive-hidden",
                              domProps: {
                                innerHTML: _vm._s(
                                  folder.additionalColumns[index].html
                                )
                              }
                            })
                          : _c("td", { staticClass: "responsive-hidden" })
                      ]
                    : _vm._e()
                }),
                _vm._v(" "),
                _c("td", {
                  staticClass: "actions",
                  domProps: { innerHTML: _vm._s(folder.actions) }
                })
              ],
              2
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "tbody",
        { staticClass: "files" },
        _vm._l(_vm.sortedFiles, function(file) {
          return _c(
            "tr",
            {
              class: file.new ? "new" : "",
              attrs: {
                id: "fileref_" + file.id,
                role: "row",
                "data-permissions": _vm.getPermissions(file)
              }
            },
            [
              _vm.show_bulk_actions
                ? _c(
                    "td",
                    [
                      _c("studip-proxied-checkbox", {
                        attrs: { name: "ids[]", value: file.id },
                        model: {
                          value: _vm.selectedIds,
                          callback: function($$v) {
                            _vm.selectedIds = $$v
                          },
                          expression: "selectedIds"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "document-icon" },
                [
                  file.download_url
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: file.download_url,
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }
                        },
                        [
                          _c("studip-icon", {
                            staticClass: "text-bottom",
                            attrs: {
                              shape: file.icon,
                              role: "clickable",
                              size: "24"
                            }
                          })
                        ],
                        1
                      )
                    : _c("studip-icon", {
                        attrs: {
                          shape: file.icon,
                          role: "clickable",
                          size: "24"
                        }
                      }),
                  _vm._v(" "),
                  file.download_url && file.mime_type.indexOf("image/") === 0
                    ? _c("a", {
                        staticClass: "lightbox-image",
                        attrs: {
                          href: file.download_url,
                          "data-lightbox": "gallery"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c(
                    "a",
                    { attrs: { href: file.details_url, "data-dialog": "" } },
                    [_vm._v(_vm._s(file.name))]
                  ),
                  _vm._v(" "),
                  file.restrictedTermsOfUse
                    ? _c("studip-icon", {
                        attrs: {
                          shape: "lock-locked",
                          role: "info",
                          size: "16",
                          title: "Das Herunterladen dieser Datei ist nur eingeschränkt möglich.".toLocaleString()
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "responsive-hidden",
                  attrs: { "data-sort-value": file.size }
                },
                [
                  file.size !== null
                    ? _c("studip-file-size", {
                        attrs: { size: parseInt(file.size, 10) }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.showdownloads
                ? _c("td", { staticClass: "responsive-hidden" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(file.downloads) +
                        "\n            "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              file.author_url
                ? _c("td", { staticClass: "responsive-hidden" }, [
                    _c("a", { attrs: { href: file.author_url } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(file.author_name) +
                          "\n                "
                      )
                    ])
                  ])
                : _c("td", { staticClass: "responsive-hidden" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(file.author_name) +
                        "\n            "
                    )
                  ]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "responsive-hidden",
                  attrs: { "data-sort-value": "file.chdate" }
                },
                [
                  _c("studip-date-time", {
                    attrs: { timestamp: file.chdate, relative: true }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.topfolder.additionalColumns, function(name, index) {
                return _vm.topfolder.additionalColumns
                  ? [
                      file.additionalColumns &&
                      file.additionalColumns[index] &&
                      file.additionalColumns[index].html
                        ? _c("td", {
                            staticClass: "responsive-hidden",
                            domProps: {
                              innerHTML: _vm._s(
                                file.additionalColumns[index].html
                              )
                            }
                          })
                        : _c("td", { staticClass: "responsive-hidden" })
                    ]
                  : _vm._e()
              }),
              _vm._v(" "),
              _c("td", {
                staticClass: "actions",
                domProps: { innerHTML: _vm._s(file.actions) }
              })
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      (_vm.topfolder.buttons && _vm.show_bulk_actions) || _vm.tfoot_link
        ? _c("tfoot", [
            _c("tr", [
              _c(
                "td",
                {
                  attrs: {
                    colspan: _vm.numberOfColumns - (_vm.tfoot_link ? 1 : 0)
                  }
                },
                [
                  _c("div", { staticClass: "footer-items" }, [
                    _vm.topfolder.buttons && _vm.show_bulk_actions
                      ? _c("span", {
                          ref: "buttons",
                          staticClass: "bulk-buttons",
                          domProps: { innerHTML: _vm._s(_vm.topfolder.buttons) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.tfoot_link
                      ? _c(
                          "span",
                          {
                            attrs: {
                              colspan:
                                _vm.topfolder.buttons && _vm.show_bulk_actions
                                  ? 1
                                  : _vm.numberOfColumns
                            }
                          },
                          [
                            _c("a", { attrs: { href: _vm.tfoot_link.href } }, [
                              _vm._v(_vm._s(_vm.tfoot_link.text))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.pagination
                      ? _c("span", {
                          staticClass: "pagination",
                          domProps: { innerHTML: _vm._s(_vm.pagination) }
                        })
                      : _vm._e()
                  ])
                ]
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }